<template>
  <footer id="Footer">
    <div class="container">
			<div class="rowView">
				<nav class="">
					<ul class="">
						<li class=""><router-link class="" to="/" :class="{linkDisable:true, linkEnable:linkStatus}">Home</router-link></li>
						<li class=""><router-link class="" to="/policy" :class="{linkDisable:true, linkEnable:linkStatus}">会社方針</router-link></li>
						<li class=""><router-link class="" to="/business" :class="{linkDisable:true, linkEnable:linkStatus}">事業内容</router-link></li>
						<li class=""><router-link class="" to="/products?list=1" :class="{linkDisable:true, linkEnable:linkStatus}">製作事例</router-link></li>
						<li class=""><router-link class="" to="/deal" :class="{linkDisable:true, linkEnable:linkStatus}">お見積り</router-link></li>
						<li class=""><router-link class="" to="/about" :class="{linkDisable:true, linkEnable:linkStatus}">会社情報</router-link></li>
						<li class=""><router-link class="" to="/recruit" :class="{linkDisable:true, linkEnable:linkStatus}">採用情報</router-link></li>
						<li class=""><router-link class="" to="/customer" :class="{linkDisable:true, linkEnable:linkStatus}">お客様窓口</router-link></li>
						<li class="" v-show="!signIn"><a @click="signOut">ログアウト</a></li>
					</ul>
					<ul>
						<li class=""><router-link :to="{ path:'/sitemap', hash:'Sitemap'}" :class="{linkDisable:true,linkEnable:linkStatus}">Sitemap</router-link></li>
						<li class=""><router-link :to="{ path:'/sitemap', hash:'PrivacyPolicy'}" :class="{linkDisable:true,linkEnable:linkStatus}">個人情報保護方針</router-link></li>
						<li class=""><router-link :to="{ path:'/sitemap', hash:'License'}" :class="{linkDisable:true,linkEnable:linkStatus}">Lisence</router-link></li>
					</ul>
				</nav>
				<ul class="officialSnsLink">
					<li><a href="https://x.com/toyoshima_p_i" rel="nofollow" class="forTip externalLink" @mouseenter="openTip" @mouseleave="closeTip" @focus="openTip" @blur="closeTip" @keyup.esc="closeTip" aria-describedby="" target="_blank"><img src="/asset/images/components/footer/logo-black.jpg" alt="X(旧Twitter)公式ページ"><span class="tip" role="tooltip" id="HomeServiceFunctions01">* X(旧Twitter)公式ページ</span></a></li>
					<li><a href="https://www.instagram.com/toyoshima_p_i" rel="nofollow" class="forTip externalLink" @mouseenter="openTip" @mouseleave="closeTip" @focus="openTip" @blur="closeTip" @keyup.esc="closeTip" aria-describedby="" target="_blank"><img src="/asset/images/components/footer/Instagram_Glyph_Gradient.jpg" alt="インスタグラム公式ページ"><span class="tip" role="tooltip" id="HomeServiceFunctions01">* Instagram公式ページ</span></a></li>
				</ul>

				<div class="certification">
					<p class="iso">
<img src="/asset/images/pages/iso/certification_number.png" alt="ISO9001:2015 認証番号GIJP-1456-QC">
					</p>
					<p class="ea21">
<img src="/asset/images/pages/ea21_logo.png" alt="エコアクション21 認証番号0009902" width="239px" height="183px">
	認証番号0009902
					</p>
				</div>

				<address class="">
〒141-0031<br> 
東京都品川区西五反田5-24-8
				</address>
				<p class="copyright">
&copy; 2025 Toyoshima Precision Industry Co., Ltd. <!--<span class="brSp"></span>All Rights Reserved.-->
				</p>
			</div>
    </div>
  </footer>
</template>

<script>
//import store from '../store'

export default {
  name:'AreaFooter',
  data: function() { 
    return { 
      linkStatus:true,
    }
  },
  computed: {
    signIn:function() {
      return !this.$store.getters.idToken
    },
  },
  methods:{
    signOut:function(){
      this.$dialog
      .confirm({
        title: 'ログアウト',
        body: 'ログアウトしてもよろしいですか？'
      },{
        okText: 'はい',
        cancelText: 'キャンセル',
      })
      .then(() => {
        this.$store.commit('updateIdToken', '')
        this.$router.push('/login')
      })
      .catch(() => {
      })
    },
  },
  beforeUpdate:function() {
    this.linkStatus = true
/*
    if ( !this.$store.getters.idToken) {
    } else {
      this.linkStatus = true
    }
*/
  },
}
</script>

<style>
</style>